import React, { useState } from 'react'
import { orderBy } from 'lodash';
import CalendarList from './CalendarList'


export default function Calendars(props){
  const { calendars, current_user } = props
  const [ fitlerValue, setFilterValue ] = useState('')
  const filteredCalendars = calendars.filter(calendar => calendar.name.toLowerCase().includes(fitlerValue.toLowerCase()))
  const sortedCalendars = [
    {
      type: 'My Calendars',
      calendars: orderBy(filteredCalendars.filter( calendar => calendar.owner.id == current_user.id && calendar.owner.type  != 'Client' && calendar.owner.type  != 'Shared'), (calendar) => { return calendar.id }, ['asc'])
    },
    {
      type: 'Client Calendars',
      canEdit: false,
      calendars: orderBy(filteredCalendars.filter( calendar => calendar.owner.type == 'Client'), (calendar) => { return calendar.id }, ['asc'])
    },
    {
      type: 'Shared Calendars',
      calendars: orderBy(filteredCalendars.filter( calendar => ( calendar.owner.type == 'Shared' )), (calendar) => { return calendar.id }, ['asc'])
    },
    {
      type: 'Other Calendars',
      calendars: orderBy(filteredCalendars.filter( calendar => calendar.owner.type != 'Shared' && calendar.owner.type != 'Client' && calendar.owner.type != 'Alumni' && calendar.owner.id != current_user.id ), (calendar) => { return calendar.id }, ['asc'])
    },
  ]

  return(
    <div className="p-1 mt-2">
      <div>
        <input 
          className="col-12 p-1 border-none border-bottom"
          placeholder="Filter calendars by name..."
          onChange={(e)=>setFilterValue(e.target.value)}/>
      </div>
      { 
        sortedCalendars.map( (sorted, index) => {
          return (sorted.calendars.length > 0 && <CalendarList key={index} title={sorted.type} canEdit={sorted.canEdit} calendars={sorted.calendars}/>)
        })
      }
    </div>
  )
}